exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".decoration-sub-title--small[data-v-2ccdc88b] {\n  width: 100%;\n  border-left: 2px solid #F08B71;\n  padding-left: 12px;\n  font-size: 1.4rem;\n  box-sizing: border-box;\n}\n", ""]);
